import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse } from '@fortawesome/free-solid-svg-icons/faHouse';
import type { IconProps } from '../../types';

export function HouseIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'House',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faHouse}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
